import { ToolIcon } from "./assets";
export const livetools = {
  maretplaceTabs: {
    displayname: "Marketplace",
    tabs: [
      {
        name: "shop",
        path: "shop",
        img: ToolIcon.shop,
        title: "Store",
      },
    ],
  },
  supportTabs: {
    displayname: "Support",
    tabs: [
      {
        name: "concierge",
        img: ToolIcon.concierge,
        path: "sector-concierge",
        title: "Concierge",
      },
      {
        name: "tickets",
        img: ToolIcon.tickets,
        path: "tickets",
        title: "My Requests",
      },
      {
        name: "newchat",
        path: "sector-support",
        img: ToolIcon.newchat,
        title: "New Chat",
      },
    ],
  },
  profileTabs: {
    displayname: "Profile",
    tabs: [
      {
        name: "timeline",
        path: "timeline",
        img: ToolIcon.timeline,
        title: "My Timeline",
      },
      {
        name: "myId",
        path: "profile",
        img: ToolIcon.myId,
        title: "My iD",
      },
      {
        name: "tokenwallet",
        path: "tokenwallet",
        img: ToolIcon.tokenwallet,
        title: "Token Wallet",
      },
      {
        name: "cardwallet",
        path: "cardwallet",
        img: ToolIcon.cardwallet,
        title: "Card Wallet",
      },
      {
        name: "bankingwallet",
        path: "bankingwallet",
        img: ToolIcon.bankwallet,
        title: "Banking Wallet",
      },
      {
        name: "openBanking",
        path: "openBanking",
        img: ToolIcon.cardwallet,
        title: "Spending Wallet",
      },
      {
        name: "friends",
        path: "friends",
        img: ToolIcon.friends,
        title: "Friends & referrals",
      },
    ],
  },
  communityTabs: {
    displayname: "Community",
    tabs: [
      {
        name: "explore",
        path: "explore",
        img: ToolIcon.explore,
        title: "Explore",
      },
      {
        name: "feeds",
        path: "feeds",
        img: ToolIcon.feeds,
        title: "News Feed",
      },
      {
        name: "hotTopic",
        path: "hot-topic",
        img: ToolIcon.hot,
        title: "Hot Topic Feed",
      },
      {
        name: "articles",
        path: "articles",
        img: ToolIcon.magazine,
        title: "Magazine",
      },
      {
        name: "polls",
        path: "polls",
        img: ToolIcon.polls,
        title: "Polls",
      },
      {
        name: "events",
        path: "events",
        img: ToolIcon.events,
        title: "Events",
      },
      {
        name: "survey",
        path: "survey",
        img: ToolIcon.survey,
        title: "Survey",
      },
      {
        name: "messages",
        path: "messages",
        img: ToolIcon.messages,
        title: "Community networking",
      },
      {
        name: "reviews",
        path: "reviews",
        img: ToolIcon.reviews,
        title: "Review",
      },
      {
        name: "iframe",
        path: "bespoke-iframe",
        img: ToolIcon.iframe,
        title: "iFrame page",
      },
    ],
  },
  shoppingTabs: {
    displayname: "Rewards",
    tabs: [
      {
        name: "ecopay",
        path: "ecopay",
        img: ToolIcon.ecopay,
        title: "Spend tokens",
      },
      {
        name: "tokenOffers",
        path: "spend",
        img: ToolIcon.tokenOffers,
        title: "Token Offers",
      },
      {
        name: "discountOffers",
        path: "discounts",
        img: ToolIcon.discountOffers,
        title: "Discount Offers",
      },
      {
        name: "earnTokens",
        path: "earn",
        img: ToolIcon.earnTokens,
        title: "Earn tokens",
      },
      {
        name: "saving",
        path: "saving",
        img: ToolIcon.saving,
        title: "Saving",
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/Constants/livetools.js